import React from "react";
//import logo from "./logo.svg";
import "./App.css";

import NavbarMainFooter from "./components/navbarMainFooter";
function App() {
  return (
    <div>
      <NavbarMainFooter />
    </div>
  );
}

export default App;
